// creategameform.ts ↔ game/creategameform.cpp — the CREATE MULTIPLAYER GAME
// form's shared constants + the CreateGameDeps bundle (kidfCreateGameWide,
// forms.ini 1068). The canvas CreateGameForm class was removed (canvas-removal
// R1); the DOM lobby drives create-game now (dom/lobby-controller.ts, which
// reuses knVersionSimulation + CreateGameDeps via LobbyShellDeps).

import type { MissionListDeps } from './missionpick.ts';
import type { CompleteManager } from '../io/completemgr.ts';

export const kidfCreateGameWide = 1068;
export const kidcCategories = 1500;
export const kidcAddOnMessage = 1501;
export const kidcChallengeList = 1503;
export const kidcAddOnList = 1504;
export const kidcGameSpeed = 1201;
export const kidcGameSpeedLabel = 1202;
export const kidcMissionPackInfo = 1002;
export const kidcChat = 1904;
export const kidcPasswordPanel = 1108;

// The MP sim/protocol version (?v= param). Single source of truth in net/httpservice.ts
// (mpshared/mpht.h:108); re-exported here for the lobby's CreateGameDeps consumers.
export { knVersionSimulation } from '../net/httpservice.ts';

/** The C++ globals this form reaches beyond ShellEnv: the mission list seams
 *  (gpakr/gppackm/gppim), gpcptm, and the LoadLevelInfo validation. */
export interface CreateGameDeps {
  mlDeps: MissionListDeps; // CreateMissionList's reaches
  completeMgr?: CompleteManager; // gpcptm (IsComplete)
  /** Level::LoadLevelInfo(miid.szLvlFilename) (creategameform.cpp:333) —
   *  default true (the mission list only enumerates loadable levels). */
  loadLevelInfo?(szLvlFilename: string): boolean;
}
